import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

export const placementsFromSettings = (list) => (list || []).map((p, i) => ({
  key: p.key, label: p.label, w: p.w, h: p.h, stitch_count: p.stitches || 5000, upcharge: Number(p.upcharge) || 0,
  method: "dtf", custom_threads: 0, on: i === 0,
}));

function MethodToggle({ value, onChange, testid }) {
  return (
    <div className="inline-flex rounded-full bg-slate-100 p-0.5 text-[11px]" data-testid={testid}>
      {[["dtf", "DTF"], ["embroidery", "Embroidery"]].map(([k, l]) => (
        <button key={k} type="button" onClick={() => onChange(k)} data-testid={`${testid}-${k}`}
          className={`px-2.5 h-6 rounded-full transition-colors ${value === k ? "bg-white shadow text-[#2495D3] font-semibold" : "text-slate-500"}`}>{l}</button>
      ))}
    </div>
  );
}

function Row({ p, i, set }) {
  const n = (k) => (e) => set({ ...p, [k]: e.target.value === "" ? "" : +e.target.value });
  return (
    <div className={`border rounded-xl px-3 py-2 transition-colors ${p.on ? "border-[#2495D3]/40 bg-[#2495D3]/5" : "border-slate-200"}`} data-testid={`placement-${p.key || i}`}>
      <div className="flex flex-wrap items-center gap-2">
        <Checkbox data-testid={`placement-${p.key || i}-on`} checked={p.on} onCheckedChange={(v) => set({ ...p, on: !!v })} />
        {p.custom ? <Input value={p.label} onChange={(e) => set({ ...p, label: e.target.value })} className="h-7 w-36 text-sm rounded-md" placeholder="Placement" />
          : <span className="text-sm font-semibold w-36">{p.label}</span>}
        {p.upcharge > 0 && <span className="text-[10px] font-mono bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded" data-testid={`placement-${p.key || i}-upcharge`}>+${p.upcharge}/pc</span>}
        {p.on && <div className="ml-auto"><MethodToggle value={p.method} onChange={(v) => set({ ...p, method: v })} testid={`placement-${p.key || i}-method`} /></div>}
      </div>
      {p.on && (
        <div className="flex flex-wrap items-center gap-2 mt-2 pl-6 text-[11px] text-slate-500">
          {p.method === "dtf" ? (<>
            W <Input type="number" value={p.w} onChange={n("w")} className="h-7 w-16 rounded-md num" data-testid={`placement-${p.key || i}-w`} />
            H <Input type="number" value={p.h} onChange={n("h")} className="h-7 w-16 rounded-md num" data-testid={`placement-${p.key || i}-h`} /> in
          </>) : (<>
            Stitches <Input type="number" value={p.stitch_count} onChange={n("stitch_count")} className="h-7 w-24 rounded-md num" data-testid={`placement-${p.key || i}-stitches`} />
            Custom thread colours <Input type="number" min="0" value={p.custom_threads} onChange={n("custom_threads")} className="h-7 w-14 rounded-md num" data-testid={`placement-${p.key || i}-threads`} />
          </>)}
          {p.custom && <>Upcharge $<Input type="number" value={p.upcharge} onChange={n("upcharge")} className="h-7 w-16 rounded-md num" /></>}
        </div>
      )}
    </div>
  );
}

export function PlacementsPicker({ placements, setPlacements }) {
  const set = (i, v) => setPlacements(placements.map((p, idx) => (idx === i ? v : p)));
  const add = () => setPlacements([...placements, { key: `custom_${placements.length}`, label: "Custom", w: 4, h: 4, stitch_count: 5000, upcharge: 0, method: "dtf", custom_threads: 0, on: true, custom: true }]);
  return (
    <div data-testid="placements-picker">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-head font-bold">Print placements</h3>
        <Button data-testid="placement-add" variant="ghost" size="sm" className="h-7 text-xs text-[#2495D3]" onClick={add}><Plus size={13} className="mr-1" />Custom</Button>
      </div>
      <div className="space-y-1.5">{placements.map((p, i) => <Row key={p.key || i} p={p} i={i} set={(v) => set(i, v)} />)}</div>
    </div>
  );
}
